var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearchW = function SvgIconSearchW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.798 17.413h-1.25l-.444-.428a10.29 10.29 0 0 0 2.344-8.452c-.745-4.4-4.419-7.913-8.853-8.452a10.3 10.3 0 0 0-8.578 2.935 10.3 10.3 0 0 0-2.936 8.572c.539 4.432 4.055 8.104 8.457 8.848a10.3 10.3 0 0 0 8.457-2.343l.428.443v1.25l6.73 6.727c.65.65 1.71.65 2.36 0 .65-.649.65-1.71 0-2.358zm-9.502 0A7.115 7.115 0 0 1 3.17 10.29a7.115 7.115 0 0 1 7.126-7.122 7.115 7.115 0 0 1 7.127 7.122 7.115 7.115 0 0 1-7.127 7.123"
  })));
};
export default SvgIconSearchW;